module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/sms-5b4f17fe816d48ba645a98ca9d60cb75.svg";